import { contentListIdsState } from "@/stores/cart";
import Checkbox from "@material-ui/core/Checkbox";
import React from "react";
import { useRecoilState } from "recoil";
import styles from "./styles.module.less";

interface IProps {
  verbose: boolean;
  id: string;
  className?: string;
}

const CheckBox: React.FC<IProps> = ({
  verbose,
  id,
  className = styles.check,
}) => {
  const [ids, setIds] = useRecoilState(contentListIdsState);

  const check = (id: string) => setIds([...new Set([...ids, id])]);

  const unCheck = (id: string) =>
    setIds([...new Set(ids.filter((_id) => _id !== id))]);

  const handleChange = (e, checked) => {
    if (checked) {
      check(id);
    } else {
      unCheck(id);
    }
  };

  if (!verbose) {
    return null;
  }

  return (
    <Checkbox
      style={{ display: verbose ? "block" : "none" }}
      className={className}
      checked={ids.includes(id)}
      onChange={handleChange}
      color="primary"
    />
  );
};

export default CheckBox;
